import { useState } from 'react';
import { sendApiRequest } from '../../api/request';
import EditingPanel from './EditingPanel';

export default function Cars() {
  const [action, setAction] = useState('create');
  const [id, setId] = useState('');
  const [language, setLanguage] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [seatRange, setSeatRange] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    setMessage('');
    if (!id || !language) {
      setMessage('Please provide both ID and language.');
      return;
    }

    try {
      if (action === 'create') {
        if (!name) {
          setMessage('Please provide a name for the car.');
          return;
        }
        const carData = {
          carId: { id: Number(id), language },
          name,
          description,
          imageUrl,
          seatRange,
        };
        const savedCar = await sendApiRequest('POST', '/admin/cars', carData);
        setMessage(`Car saved: ${savedCar?.name ?? 'unknown'} (${savedCar?.carId?.language ?? language})`);
      } else {
        await sendApiRequest('DELETE', `/admin/cars/car?id=${id}&language=${language}`);
        setMessage(`Car with ID ${id} (${language}) deleted.`);
      }

      setId('');
      setLanguage('');
      setName('');
      setDescription('');
      setImageUrl('');
      setSeatRange('');
    } catch (error) {
      setMessage(`${error?.message ?? 'Request failed'}`);
    }
  };

  return (
    <EditingPanel
      title={action === 'create' ? 'Create / Update Car' : 'Delete Car'}
      action={action}
      onActionChange={setAction}
      actions={[
        { value: 'create', label: 'Create / Update' },
        { value: 'delete', label: 'Delete' },
      ]}
      topRow={
        <>
          <div className="editing-panel__field">
            <label>Car ID</label>
            <input type="number" value={id} onChange={(e) => setId(e.target.value)} placeholder="Enter car ID" />
          </div>
          <div className="editing-panel__field">
            <label>Language</label>
            <input type="text" value={language} onChange={(e) => setLanguage(e.target.value)} placeholder="e.g. en or no" />
          </div>
        </>
      }
      grid={
        action === 'create' && (
          <>
            <div className="editing-panel__field">
              <label>Car Name</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter car name" />
            </div>

            <div className="editing-panel__field editing-panel__field--span-2">
              <label>Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description"
              />
            </div>

            <div className="editing-panel__field">
              <label>Image URL</label>
              <input
                type="text"
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
                placeholder="e.g. uploads/car.jpg"
              />
            </div>

            <div className="editing-panel__field">
              <label>Seat Range</label>
              <input
                type="text"
                value={seatRange}
                onChange={(e) => setSeatRange(e.target.value)}
                placeholder="e.g. 9-16"
              />
            </div>
          </>
        )
      }
      onSubmit={handleSubmit}
      isDanger={action === 'delete'}
      submitLabel={action === 'delete' ? 'Delete Car' : 'Save Car'}
      message={message}
    />
  );
}
